import {
  CarbonIntensityEnv,
  getCarbonIntensityValue,
  HvacArea,
  ProjectData,
  ProjectHvacConsumption,
  Resolver,
} from '@belimo-retrofit-portal/logic';
import { flow, pipe } from 'fp-ts/function';
import { ask, map, Reader } from 'fp-ts/Reader';
import * as L from 'monocle-ts/Lens';

export const setInitialCarbonIntensity: Reader<CarbonIntensityEnv, Resolver<ProjectData>> = pipe(
  ask<CarbonIntensityEnv>(),
  map((environment) => resolveCarbonIntensity(environment)),
);

function resolveCarbonIntensity(
  environment: CarbonIntensityEnv,
): Resolver<ProjectData> {
  return flow(
    resolveConsumption(environment, HvacArea.COOLING, 'thermal'),
    resolveConsumption(environment, HvacArea.HEATING, 'thermal'),
    resolveConsumption(environment, HvacArea.VENTILATION, 'thermal'),

    resolveConsumption(environment, HvacArea.COOLING, 'electrical'),
    resolveConsumption(environment, HvacArea.HEATING, 'electrical'),
    resolveConsumption(environment, HvacArea.VENTILATION, 'electrical'),
  );
}

function resolveConsumption(
  environment: CarbonIntensityEnv,
  hvacArea: HvacArea,
  energyType: 'thermal' | 'electrical',
): Resolver<ProjectData> {
  return pipe(
    L.id<ProjectData>(),
    L.prop('hvac'),
    L.prop('areas'),
    L.prop(hvacArea),
    L.prop(energyType),
    L.modify(resolveConsumptionValue(environment)),
  );
}

function resolveConsumptionValue(
  environment: CarbonIntensityEnv,
): Resolver<ProjectHvacConsumption> {
  return (consumption) => pipe(
    L.id<ProjectHvacConsumption>(),
    L.prop('carbonIntensity'),
    L.modify((currentValue) => (
      getCarbonIntensityValue(environment)(consumption.energySource)
    )),
  )(consumption);
}
